import green from '@material-ui/core/colors/green'
import amber from '@material-ui/core/colors/amber'
import red from '@material-ui/core/colors/red'
import blueGrey from '@material-ui/core/colors/blueGrey'
import grey from '@material-ui/core/colors/grey'

import { lighten, darken } from '@material-ui/core/styles/colorManipulator'
import { createMuiTheme, Theme, StyleRules, createStyles, withStyles } from '@material-ui/core/styles'

import ConstructionBackground from '../assets/construction-background.jpg'
import Typography from '@material-ui/core/Typography'
import { Button, TextField } from '@material-ui/core'

export const areaStyle = (theme: Theme) => ({
    whiteTextField:{
        color:'red'
    },
    AreaFullScreenContainer:{
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.2)',
        'backdrop-filter': 'blur(8px)',
        display: 'flex',
        flexDirection: 'column',
    },
    AreaBlueprintItemRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        paddingRight: '16px'
    },
    AreaFullScreenTop: {
        paddingLeft: '32px',
        paddingTop: '32px',
        borderBottom: '1px solid rgba(255, 255, 255, .2);'
    },
    AreaFullScreenTopTitle: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 24,
        color: '#fff',
        margin: '0px'
    },
    AreaFullScreenBottom: {
        display: 'flex',
        height: '100%'
    },
    SixteenMarginLeft: {
        marginLeft: '16px !important'

    },
    AreaFullScreenTopSubTitle: {
        marginLeft: '0px',
        marginRight: '0px',
        marginTop: '0px',
        marginBottom: '0px',
        color: '#fff',
        opacity: '0.5',
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 14,
    },
    AreaScreenTitle: {
        color: '#000',
        fontSize: 22,
        fontFamily: 'Roboto',
        margin: 0,
        textTransform: 'none',
        fontWeight: 400
    },
    TransparentButton: {
        zIndex: 2,
        backgroundColor: 'Transparent', 
        border: 'none', 
        padding: 0,
        'background-repeat':'no-repeat',
        'cursor':'pointer',
        'outline':'none',
        '&:before': {
            outline:0,
        },
        '&:active': {
            outline: 'none',
            border: 'none'
        },
    },
    AreaScreenTop: {
        marginTop: '40px'
    },
    AreaScreenCollectionContainer: {
        marginTop: 16,
        display: 'grid',
        gridGap: '24px',
        "grid-template-columns": "auto auto auto"
    },
    AreaScreenCollectionBlueprint: {
        background: 'linear-gradient(180.32deg, rgba(255, 255, 255, 0) -52.55%, #FFFFFF 99.72%), url(competitor.png)',
        filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.1))',
        'border-radius': '4px',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        paddingLeft: '19px',
        paddingBottom: '22px'
    },
    AreaScreenCollectionItem: {
        width: '281px',
        height: '128px',
        'border-radius': '4px',

    },
    NewDialogFormTitleText: {
        marginTop: '36px',
        fontSize: '22px',
        'font-family': "Roboto"
    },
    NewDialogFormTitle: {
        margin: '-24px',
        width: 'auto',
        backgroundColor: '#D0051B',
        paddingLeft: 56,
        paddingTop: 36,
        paddingBottom: 8,
    },
    AreaScreenEmptyContainer: {
        display: 'flex',
        width: '100%',
        height: '70%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    AreaDropzoneStyle: {
        width: "50%",
        minWidth: "800px",
        height: "300px",
        display: "flex",
        border: "1px dashed #3973BE",
        borderRadius: '4px'
    },
    AreaDropzoneContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    }
})

export const styles: (theme: Theme) => StyleRules<string> = theme => createStyles({
    SixteenMarginLeft: {
        marginLeft: '16px !important'

    },
    ReportViewRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    ReportNumberBackground: {
        margin: 0, 
        fontSize: 16, 
        fontWeight: 'bold', 
        color: '#fff'
    },
    ReportQuestion: {
        fontFamily: 'Roboto',
        fontWeight: 'bold',
        fontSize: 16
    },
    ReportAnswer: {
        fontFamily: 'Roboto',
        fontWeight: 600,
        fontSize: 20
    },
    ReportNumber: {
        display: 'flex', 
        height: 26, 
        width: 26, 
        backgroundColor: '#2488FE', 
        borderRadius: (26/2), 
        justifyContent: 'center', 
        alignItems: 'center', 
        marginRight: 14
    },
    box: {
        width: '50%',
        '&:after': {
            content: "",
            display: 'block',
            paddingTop: '100%'
        }
    },
    FullScreenBottom: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '27px',
        paddingBottom: '47px',
        overflowY: 'hidden'
        
    },
    FullScreenContainer:{
        overflow: 'hidden',
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'rgba(0, 0, 0, 0.2)',
        'backdrop-filter': 'blur(8px)'
    },
    FullScreenTop: {
        paddingLeft: '16px',
        paddingTop: '16px',
        paddingBottom: '16px',
        borderBottom: '1px solid rgba(255, 255, 255, .2);'
    },
    FullScreenTopTitle: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 24,
        color: '#fff',
        margin: '0px'
    },
    FullScreenTopSubTitle: {
        marginLeft: '0px',
        marginRight: '0px',
        marginTop: '0px',
        marginBottom: '0px',
        color: '#fff',
        opacity: '0.5',
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 14,
    },
    GroupButton: {
        border: '1px solid #C4C4C4',
        'box-sizing': 'border-box',
        'border-radius': '4px',
        width: 18,
        height: 18,
        marginTop: 4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 18,
        cursor: 'pointer'
    },
    MRPColumn: {
        height: '100vh',
        width: '100vw',
    },
    GroupButtonOpen: {
        width: 10,
        height: 2,
    },
    GroupButtonContainer: {
        height:  '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    GroupButtonDivider: {
        width: 1,
        marginTop: 4,
        height: '40%',
        
    },
    GroupButtonClosed: {
        border: '1px solid #C4C4C4',
        'box-sizing': 'border-box',
        'border-radius': '4px',
        width: 18,
        height: 18
    },

    profileContainer: {
        height: '100vh',
        marginRight: "32px",
        marginLeft: "32px",
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
    },
    fullVertical: {
        height: '100%'
    },
    RelativeColumn: {

    },
    fullCenter: {
        display: 'flex',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    flexGrowRoot: {
        flexGrow: 1,
        height: "100vh",
        display: "flex"
    },
    flexRoot: {
        flexGrow: 1,
        display: "flex"
    },
    editBoardContainer: {
        paddingBottom: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingLeft: "10px",
        height: "100vh"
    },
    pageContainer: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column"
    },
    ganttContainer: {
        marginLeft: "-24px",
        marginRight: "-24px",
        marginBottom: "-24px",
        height: "100vh"
    },
    ganttChartContainer: {
        height: "100vh"
    },
    profilePaper: {
        paddingRight: "32px",
        paddingLeft: "32px",
        paddingTop: "15px",
        paddingBottom: "15px"
    },
    profileDivider: {
        marginTop: "16px",
        marginBottom: "16px"
    },
    profilePaperHeader: {
        marginTop: "8px"
    },
    sectionPaperHeader: {
        marginTop: "16px",
        marginBottom: "16px",
        color: "#000"
    },
    flex: {
        display: "flex"
    },
    editBoardHeader: {
        flexDirection: "row",
        flexGrow: 1,
        display: "flex"
    },
    menuIconHeaderContainer: {},
    saveButton: {
        width: "100%"
    },
    closeIconHeader: {
        marginBottom: "6px",
        marginRight: "8px"
    },
    menuIconHeader: {},
    editBoardRightHeader: {
        display: "flex",
        marginBottom: "8px",
        flex: 1,
        justifyContent: "flex-end"
    },
    flexWrap: {
        flexWrap: "wrap"
    },
    profilePaperTitle: {
        marginBottom: "8px"
    },
    taskTableContainer: {
        marginTop: "16px"
    },
    standardMarginBottom: {
        marginBottom: "16px"
    },
    gridList: {
        overflowX: "scroll",
        flexWrap: "nowrap",
        height: "110px",
        marginTop: "8px"
    },
    FileListItemIconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
    },
    CenterContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        flexDirection: "column"
    },
    FilesTypography: {
        display: "inline"
    },
    IssueListGridTile: {
        margin: "10px",
        height: "80% !important",
        width: "20% !important",
        borderColor: "#dddbda",
        borderRadius: 3,
        borderStyle: "solid",
        borderWidth: 1,
    },
    IssueItemGridContainerCircularProgress: {
        position: "relative",
        textAlign: "center",
        height: "100%",
        paddingTop: "12.5%",
    },
    FileListGridTile: {
        margin: "10px",
        height: "80% !important",
        width: "30% !important",
        borderColor: "#dddbda",
        borderRadius: 3,
        borderStyle: "solid",
        borderWidth: 1,
    },
    FileItemGridContainer: {
        position: "relative",
        textAlign: "center",
        height: "100%",
    },
    FileItemGridContainerCircularProgress: {
        position: "relative",
        textAlign: "center",
        height: "100%",
        paddingTop: "20%",
    },
    FileItemCopyIcon: {
        opacity: 0.25,
        position: "absolute",
        height: "70% !important",
        width: "70% !important",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    FileItemFileName: {
        align: "center",
        noWrap: "false",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    FileListItem: {
        display: "flex",
        borderColor: "#dddbda",
        borderRadius: 3,
        borderStyle: "solid",
        borderWidth: 1,
        height: "100px",
        width: "100px",
        marginTop: 8,
        marginBottom: 10,
        marginRight: 10,
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 10,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "flex-start"
    },
    leftBigForm: {
        backgroundColor: "#fff",
    },
    rightBigForm: {
        backgroundColor: "#4286dd",
        backgroundImage: `url(${ConstructionBackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width:'50%'

    },
    loginBackgroundBackground: {
        backgroundColor: "#4286dd",
        width: "100%",
        height: "100%",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column"
    },
    success: {
        backgroundColor: green[600]
    },
    error: {
        backgroundColor: theme.palette.error.dark
    },
    info: {
        backgroundColor: theme.palette.primary.dark
    },
    warning: {
        backgroundColor: amber[700]
    },
    icon: {
        fontSize: 20
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit
    },
    message: {
        display: "flex",
        alignItems: "center"
    },
    dashboardPaper: {
        padding: "16px",
        overflowX: "scroll",
        minHeight: "400px",
        maxHeight: "400px"
    },
    dashboardIssues: {
        padding: '16px',
        display: 'flex',
        alignItems: 'center'
    },

    dashboardTasks: {
        display: 'grid'
    },

    taskNumber: {
        marginRight: '15px',
        color: 'red'
    },
    overviewHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 8,
        marginRight: 8
    },
    huddleButtons: {
        marginTop: 0,
        marginBottom: 0,
        marginRight: 32,
        fontSize: 20,
        fontFamily: 'Roboto',
        fontWeight: 400
    },
    huddleButtonUnderlineOn: {
        width: '100%',
        height: 3,
        backgroundColor: '#4286DD',
        marginTop: 5
    },
    huddleButtonOff: {
        color: '#AAAAAA'
    },
    huddleButtonOn: {
        color: '#000'
    },
    uploadButtonContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    uploadButton: {
        margin: "10px"
    },
    menuButton: {
        marginRight: "auto",
        marginLeft: "auto"
    },
    centeredHorizontal: {
        justifyContent: "center"
    },
    centeredVertical: {
        alignItems: "center"
    },

    standardTopPadding: {
        paddingTop: "32px"
    },
    flexColumn: {
        flexDirection: "column"
    },
    DropzoneStyle: {
        width: "100%",
        minWidth: "400px",
        height: "300px",
        flexGrow: 1,
        display: "flex",
        border: "2px dashed #888"
    },
    uploadStatusBar: {
        marginTop: "16px",
        backgroundColor: "#a1bdd0",
        borderRadius: "5px",
        padding: "5px"
    },
    fileListTitle: {
        marginTop: "16px"
    },
    AllTasksScreenTableHeader: {
        backgroundColor: "#f1f5f6"
    },
    AllTasksScreenTableButtons: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: "16px"
    },
    AllTasksScreenAddButton: {
        marginLeft: "16px"
    },
    AllTasksScreenProgressBar: {
        width: "100%",
        height: "2em"
    },
    AllTasksScreenVisibilityIcon: {
        outline: "none"
    },
    sendButton: {
        borderColor: green[600],
        color: green[600]
    },
    cancelButton: {
        borderColor: red[600],
        color: red[600]
    },
    ganttToolbar: {
        display: "flex",
        paddingTop: "8px",
        paddingBottom: "8px",
        justifyContent: "flex-end",
        backgroundColor: "#f1f5f6"
    },
    ganttToolbarButton: {
        marginLeft: "8px",
        marginRight: "8px"
    },
    topBannerLI: {
        padding: "1%",
        flex: "1",
        textAlign: "left"
    },
    topBannerTitle: {
        color: "rgba(8, 24, 40, 0.7)",
        fontSize: "16px"
    },
    topBannerMetric: {
        color: "#000",
        fontSize: "14px"
    },
    topBanner: {
        fontFamily: "Roboto",
        padding: "0px",
        display: "flex",
        listStyleType: "none",
        margin: "0px"
    },
    scheduleContainer: {
        padding: "3%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    scheduleButton: {
        cursor: "pointer"
    },
    centerItemsHoriz: {
        display: "flex",
        justifyContent: "center"
    },
    scheduleToggleContainer: {
        display: "flex",
        flexShrink: 1,
        marginBottom: "16px"
    },
    circleProgress: {
        margin: "auto"
    },
    circleProgressDialog: {
        margin: "16px"
    },
    chipBackground: {
        width: "99px",
        height: "32px",
        borderRadius: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    chipText: {
        color: "#fff",
        fontFamily: "Roboto",
        fontSize: "13px",
        fontWeight: "bold"
    },
    yellow: {
        backgroundColor: "#ffeb3b",
        color: "#000"
    },
    blue: {
        backgroundColor: "#42a5f5",
        color: "#fff"
    },
    green: {
        backgroundColor: "#43a047",
        color: "#fff"
    },
    red: {
        backgroundColor: "#f44336",
        color: "#fff"
    },
    nonselected: {
        backgroundColor: "#eeeeee",
        color: "#fff"
    },
    disabledPill: {
        backgroundColor: "#757575",
        color: "#fff"
    },
    LookAheadStatusContainer: {
        display: "flex",
        width: "100%",
        marginBottom: "8px"
    },
    LookAheadStatusPill: {
        marginRight: "8px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    emptyStateContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh"
    },
    emptyStateButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
    },
    emptyStateIcon: {
        width: "8em",
        height: "8em",
        color: "black"
    },
    projectViewPickerContainer: {
        display: "flex",
        alignItems: "center"
    },
    ppcReviewSubContainer: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: "32px",
        paddingTop: "32px",
        paddingBottom: "60px",
        height: "100%"
    },
    ppcHeaderFont: {
        fontSize: "20px"
    },
    ppcSummarySubContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
    },
    pccPaper: {
        height: "290px"
    },
    ppcSummarySubTitle: {
        fontSize: "16px"
    },
    scheduleToolbar: {
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "#f1f5f6"
    },
    scheduleLeftToolbar: {
        width: "30%",
        display: "flex",
        justifyContent: "space-evenly",
        marginTop: "12px"
    },
    headerText: {
        fontFamily: "Roboto",
        fontSize: "12px",
        fontWeight: 500,
        textAlign: "center",
        color: "rgba(8, 24, 40, 0.56)"
    },
    scheduleToolbarItem: {
        cursor: "pointer"
    },
    neweditBoardHeader: {
        display: "flex",
        justifyContent: "space-between"
    },
    editBoardHeaderText: {
        fontFamily: "Roboto",
        fontSize: "20px",
        letterSpacing: "0.2px",
        color: "#081828"
    },
    bigTopMargin: {
        marginTop: "32px"
    },
    standardTopMargin: {
        marginTop: "16px"
    },
    standardBottomMargin: {
        marginBottom: "16px"
    },
    standardardLeftMargin: {
        marginLeft: "16px"
    },
    standardardRightMargin: {
        marginRight: "16px"
    },
    smallRightMargin: {
        marginRight: "8px"
    },
    verticalFlex: {
        display: "flex",
        flexDirection: "column"
    },
    standardSeperated: {
        display: "flex",
        justifyContent: "space-between",
        width: '100%',
    },
    standardEvenlySeperated: {
        display: "flex",
        justifyContent: "space-evenly",
        width: '100%',
    },
    sideBysideButton: {
        flexGrow: 1,
        margin: '.3em'
    },
    standardRow: {
        display: "flex",
        flexDirection: "row",
    },
    spacedRow: {
        justifyContent: 'space-between'
    },
    centeredDiv: {
        display: "flex",
        alignItems: "center"
    },
    fullPage: {
        width: "100%",
        height: "100vh"
    },
    deleteDialog: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    arrowDropDown: {
        marginTop: '0',
        padding: '0',
        display: 'block'
    },
    showMoreButtonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    showMoreButton: {
        marginTop: '1rem',
        border: 'none',
        padding: '0',
        display: 'block',
    },
    issuesTableStatusDone: {
        backgroundColor: green[500],
        color: 'white',
        paddingLeft: '0.7rem',
        paddingRight: '0.7rem',
    },
    issuesTableStatusNotDone: {
        backgroundColor: red[500],
        color: 'white',
    },
    issuesTableStatusError: {
        backgroundColor: 'grey',
        color: 'white',
        paddingLeft: '0.7rem',
        paddingRight: '0.7rem',
    },
    unclickButton: {
        color: '#000'
    },
    done: {
        color: green[500]
    },
    notdone: {
        color: red[500]
    },
    PhaseContainer: {
        overflowY: 'hidden',
        marginLeft: -24,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
    },
    PhaseScreenTopBar: {
        paddingTop: 4,
        paddingBottom: 4,
        maxHeight: '10vh',
        backgroundColor: '#4a4a4a',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 16,
        'webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none'
    },
    PhaseScreenTitle: {
        color: '#fff',
        fontSize: 18,
        fontFamily: 'Roboto',
        margin: 0,
        textTransform: 'none'
    },
    BackLogMain: {
        width: '100%',
        minHeight: '20vh',
        backgroundColor: '#d8d8d8',
        flexDirection: 'column',
        display: 'flex',
        height: '100%'
    },
    BackLogButtonHolder: {
        height: 48,
        width: '100%',
        display: 'flex',
    },
    DialogFormTitle: {
        margin: '-24px',
        width: 'auto',
        backgroundColor: '#D0051B',
        paddingLeft: 24,
        paddingTop: 8,
        paddingBottom: 8,
    },
    DialogFormTitleText: {
        fontFamily: 'Roboto',
        fontSize: 16,
        fontWeight: 'bold',
        color: '#ffffff',
        margin: 0
    },
    DialogFormContent: {
        marginTop: 32,
        overflowY: 'visible',
        height: '100%'
    },
    DialogFormField: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginTop: 16,
        marginBottom: 16,
        overflowY: 'visible',
    },
    DialogFormLabel: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 16,
        fontFamily: 'Roboto',
        fontSize: 14
    },
    DialogHelpFormLabel: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        fontFamily: 'Roboto',
        fontSize: 18
    },
    DialogHelpTable: {
        '& tr':{
        }
    },
    DialogFormHelpLabel: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 16,
        fontFamily: 'Roboto',
        fontSize: 12,
        color: grey[500]

    },
    DialogFormHelpInfoTitle: {
        backgroundColor: '#4286dd'
    },
    DialogFormIsMilestone: {
        padding: 0,
        marginTop: '25px',
    },
    PhasePlanMain: {
        width: '102vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
        'webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none'
    },
    PhasePlanTagMain: {
        width: '100%',
        height: '100%',
        display: 'flex'
    },
    PhasePlanTrade: {
        height: '100%',
        width: 100,
        position: 'sticky',
        backgroundColor: '#d8d8d8',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    PhasePlanScrollContainer: {
        flex: 'none'
    },
    GONE: {
        display: 'none !important'
    },
    DrawerContainer: {
        width: '100%',
        marginLeft: '20px'
    }, 
    DrawerBacklogContainer: {
        width: '100%',
        display: 'flex',
        paddingRight: '8px'
    }, 
    DrawerBacklogButton: {
        minWidth: '32px',
        height: '120px',
        marginLeft: '10px', 
        borderStyle: 'dashed'
    }, 
    DrawerTradesContainer: {
        display:'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
    
    },
    DrawerTradesButton: {
        borderStyle: 'dashed',
        borderRadius: '10px',
    }, 
    DrawerTitle: {
        textOrientation: 'sideways',
        writingMode: 'vertical-rl',
        margin: 0,
        width: '100%',
        whiteSpace: 'nowrap',
        zIndex: 9999,
        fontSize: 18,
        fontWeight: 500,
        transform:'scale(-1)',
        paddingRight: '0px !important'
    },
    DrawerButtonGroup: {
        marginTop: '5px',
    }, 
    RightDrawerButton: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 2,
        height: '100%',
        width: '50px',
        backgroundColor: 'Transparent', 
        border: 'none', 
        padding: 0,
        marginLeft: 0,
        'background-repeat':'no-repeat',
        'cursor':'pointer',
        'outline':'none',
        '&:before': {
            outline: 'none',
        },
        '&:active': {
            outline: 'none !important',
            border: 'none !important'
        },
        '&:focus': {
            outline: 'none',
        }
    },
    DrawerMenuIcon: {
        marginTop: 16
    },
    PhasePlanTradeListSection: {
        display: 'grid',
        paddingRight: '20px',
        width: '110%',
        gridTemplateColumns: 'repeat(4, minmax(90px, 1fr))',
        height: 'fit-content',
        overflow: 'scroll !important',
    },
    DrawerTitleContainer:{
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    RightDrawer: {
        zIndex: 999,
        boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.2)',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
        top: '6.58vh',
        height: '100%',
        width: 100,
        position: 'sticky',
        backgroundColor: '#FFFDFD',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'flex-start',
        overflowY: 'scroll !important',
        overflowX: 'hidden'
    },
    rightDrawerOpenNormal: {
        'min-width': '500px',
    },
    rightDrawerOpenFullscreen: {
        'min-width': '100%',

    },
    rightDrawerOpen: {
        // position: 'relative',
        // width: 600,
        right: 240,
        zIndex: 999,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        })
    },
    ZoomContainer: {
        minWidth: '150px', 
        position: 'absolute', 
        bottom: "5vh", 
        right: '5vw'
    },
    rightDrawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        width: 46,
        minWidth: 46,
        position: 'absolute',
        height: '93.3vh', 
        right: 0,
        bottom: 60,
        backgroundColor: '#F3F3F3',
        boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.2) !important',
    },
    DrawerList: {
        zIndex: 100,
        height: '100%',
        width: '85%',
        display: 'flex',
        justifyContent: 'flex-start'
    }, 
    DrawerListClosed: {
        display: 'none',
    },
    DrawerListSection: {
        display: 'flex',
        flexDirection: 'column',
        paddingRight: '30px',
        width: '100%'
    },
    PhasePlanDrawerBacklogs:  {
        overflow: 'scroll',
    }, 
    DrawerButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        margin: '5px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    DrawerButton: {
        margin: '5px',
    }, 
    PhasePlanTagList: {
        'grid-template-rows': '1fr 1fr',
        'grid-auto-flow': 'column',
        zIndex: 999,
        display: 'inline-grid',
        flexWrap: 'nowrap',
        overflow: 'scroll',
        width: '100%',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        'scrollbar-width': '1px',
        '-ms-overflow-style': 'none',
        '&::-webkit-scrollbar': {
          width: 0,
          height: '8px !important',
          background: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'darkgrey',
            borderRadius:' 30px !important',
        }
    },

    PhasePlanTradeList: {
        overflowY: 'scroll',
        zIndex: 2,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
    },
    BacklogTags: {
        overflow: 'scroll !important' 
    }, 
    TransparentButton: {
        zIndex: 2,
        backgroundColor: 'Transparent', 
        border: 'none', 
        padding: 0,
        marginLeft: 28,
        'background-repeat':'no-repeat',
        'cursor':'pointer',
        'outline':'none',
        '&:before': {
            outline:0,
        },
        '&:active': {
            outline: 'none',
            border: 'none'
        },
    },
    ZoomButtonContainer: {
        // position: "element(.RightDrawerButton)",
        transform: "translateX(-50%)",
        position: "relative",
        bottom: "5vh",
        // right: "100px"
    }, 
    ZoomButtons: {
        width: '40px',
        height: '40px',
        borderRadius: '50%', 
        background: '#4286DD',
        opacity: 0.75,
        margin: '0.3em',
        '&:focus': {
            background: '#4286DD',
            outline: 'none',
        }, 
        '&:active': {
            background: '#4286DD',
            outline: 'none',
        },
        '&:hover': {
            background: '#4286DD',
            opacity: 0.3
        },
        boxShadow: '0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)'
    }, 
    ZoomIcons: {
        color: 'white'
    },

    UtilityButtonsContainer: {
        position: "absolute", 
        bottom: "10vh", 
        left: "350px", 
        display: 'flex',
        zIndex: 999,
    }, 
    UtilityButtonsIconContainer: {
        opacity: 0.7,
    },
    CircularButton: {
        zIndex: 999, 
        borderStyle: 'solid', 
        opacity: 0.75,
        display:'flex',
        flexDirection: 'row', 
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%', 
        width: '80px', 
        height: '80px',
        margin: '5px',
        paddingTop: '10px',
        'outline':'none',
        '&:focus': {
            boxShadow: 'none',
            outline: 'none'
        }, 
        '&:active': {
            outline: 'none',
            border: 'none',
            boxShadow: 'none',
            transform: 'none'
        },
        '&:hover': {
            transform: 'none',
            borderStyle: 'dashed', 
        }, 
        '&:click': {
            transform: 'none'
        }, 
        '& p': {
            fontSize: '10px',
            textAlign: 'center',
            fontWeight: 500,
            lineHeight: '18px',
        }
    },
    CircularButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }, 
    PhasePlanTradeCard: {
        width: 84,
        height: 50,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 16,
        overflow: 'hidden',
        borderRadius: '10px',
        boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)',
        '& td': {
            fontFamily: 'Roboto',
            fontSize: 5
        }
    },
    TagCardLocationLabel: {
        margin: '0px',
        textAlign: 'center',
        backgroundColor: '#e0e0e0',
        borderBottom: '2px solid',
        marginBottom: '3px',
    },
    TagCardLabel:{
        margin: '0px',
        textAlign: 'center',
    },
    TagLocationText: {

    },
    PhasePlanTagCardConstraintText:{
        '&::before': {
            shapeOutside: 'polygon\(2\% 0%\, 100\% 0%\,100\% 100%\, 2\% 100%\, 50\% 94%\, 76.6\% 82.7%\, 94\% 65.6%\, 100\% 50%\, 94\% 32.6%\, 76.6\% 17.3%\, 50\% 6\% )',
            shapeMrgin: '7%',
            content: "",
            float: 'right',
            height: '100%',
            width: '50%'
        }
    },
    'ripple': {
        position: 'relative',
        overflow: 'hidden',
        transform: 'translate3d(0, 0, 0)',
        '&:active': {
            content: "",
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            'pointer-events': 'none',
            'background-image': 'radial-gradient(circle, #fff 10%, transparent 10.01%)',
            'background-repeat': 'no-repeat',
            'background-position': '50%',
            'transform': 'scale(10, 10)',
            'opacity': 0,
            'transition': 'transform .5s, opacity 1s'
        }
    },
      
    'ripple:after': {
        content: "",
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        'pointer-events': 'none',
        'background-image': 'radial-gradient(circle, #fff 10%, transparent 10.01%)',
        'background-repeat': 'no-repeat',
        'background-position': '50%',
        'transform': 'scale(10, 10)',
        'opacity': 0,
        'transition': 'transform .5s, opacity 1s'
    }, 
    'ripple:active:after': {
        transform: 'scale(0, 0)',
        opacity: .3,
        transition: '0s'
    },
    TagBottomContent: {
        width: '100%',
        height: '100%',
        'overflow-y': 'hidden'
    },
    TagStatusBottomContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        paddingRight: '5%' 
    },
    TagStatusIndicator: {
      borderRadius: '50%',
    },
    ProjectTitle: {
        fontSize: '22px',
        color: '#3973BE'
    },
    ProjectContentContainer: {
        marginLeft: 55,
        marginRight: 55,
        marginBottom: 32

    },
    ProjectSubtitle: {
        fontSize: '18px',
        color: '#000'
    },
    ProjectTitleContainer: {
        marginTop: 32,
        marginLeft: 55,
        width: '100%'
    },
    RotateTag: {
        transform: 'rotate(45deg)',
        transformOrigin: 'center'
    },
    TagNameText: {
        lineHeight: 'normal',
        'text-overflow': 'ellipsis',
        'overflow': 'hidden'
    },
    SmallPhaseTagCard: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        '& p': {
            fontSize: '0.5em',
            textAlign: 'center',
            '-webkit-user-select': 'none',  
            '-moz-user-select': 'none',   
            '-ms-user-select': 'none',      
            'user-select': 'none'
        }
    },
    LargePhaseTagCard: {
        '& td': {
            fontSize: '0.5em'
        }
    },
    PhasePlanLocationListContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'

    },
    PhasePlanLocationRow: {
        width: '100%',
        height: "100%",
        display: 'flex',
        flexDirection: 'column'
    },
    PhasePlanLocationRowHeader: {
        width: '10000px',
        height: 60,
        backgroundColor: '#b2afb3',
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 12,
        paddingTop: 10,
    },
    PhasePlanLocationRowHeaderStuff: {
        marginLeft: 20,
        '& td': {
            fontFamily: 'Roboto',
            fontSize: 9,
        }
    },
    PhasePlanLocationRowHeaderP: {
        fontFamily: 'Roboto',
        fontSize: 9,
    },
    PhasePlanLocationRowHeaderTitle: {
        fontFamily: 'Roboto',
        fontSize: 15,
    },
    PhasePlanLocationGrid: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexWrap: 'nowrap',
        'scrollbar-width': 'none',
        '-ms-overflow-style': 'none',
        '&::-webkit-scrollbar': {
          width: 0,
          background: 'transparent'
        }
    },

    hideOverFlowY:{
        overflowY: 'hidden'
    },
    PhasePlanColumnTrigger: {
        height: '100%',
        width: '100%',
    },
    ForceRefreshButton: {
        '&:hover': {
            backgroundColor: 'rgba(66, 134, 221, .2)'
        }
    },
    CrossOutLineRightMilestone: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(-5px) translateX(15.5px) rotate(90deg)',
        position: 'absolute'
    }, 
    CrossOutLineLeftMilestone: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(13.5px) translateX(-4.5px) rotate(180deg)',
        position: 'absolute'
    }, 
    CrossOutLineRightMilestoneBacklog: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(-5px) translateX(27.5px) rotate(90deg)',
        position: 'absolute'
    }, 
    CrossOutLineLeftMilestoneBacklog: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(25.5px) translateX(-4.5px) rotate(180deg)',
        position: 'absolute'
    }, 
    CrossOutLineRightConstraint: {
        width: '85%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(-24.5px) translateX(25px) rotate(45deg)',
        position: 'absolute'
    }, 
    CrossOutLineLeftConstraint: {
        width: '85%',
        height: '90%',
        borderBottom: 'solid',
        transform: 'translateY(19px) translateX(18px) rotate(135deg)',
        position: 'absolute'
    }, 
    CrossOutLineRightConstraintBacklog: {
        width: '90%',
        height: '110%',
        position: 'absolute',
        transform: 'translateY(-45px) translateX(43px) rotate(45deg)',
        borderBottom: 'solid',
    },
    CrossOutLineLeftConstraintBacklog: {
        width: '90%',
        height: '90%',
        position: 'absolute',
        transform: 'translateY(30px) translateX(33px) rotate(135deg)',
        borderBottom: 'solid',
    },
    MilestoneForeground: {
        color: '#333',
        height: '50%',
        transform: 'rotate(-45deg)',
        width: '100%',
    },
    DateColumn:{
        zIndex: 10,
        backgroundColor: '#fff'
    },
    GroupNameText: {
        whiteSpace: 'pre',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginRight: '8px',
        'text-align': 'center',
        'margin-top': '0px',
        'margin-left': '0px',
        'margin-bottom': '0px'
    },
    DateColumnOpen:{
        minWidth: '120px'
    },
    RowCountIndicatorContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    DateColumnNumberOpen:{
        paddingRight: '12px',
        paddingLeft: '3px',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',

    },
    DateColumnNumberClose: {
        paddingRight: '3px',
        paddingLeft: '3px',

        alignItems: 'center',
        justifyContent: 'center',


    },

    DatePadding:{
        paddingRight: '6px'
    },
    ColumnTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
        overflowX: 'auto'
    },
    LHColumnTitleContainer: {
        display: 'flex',
        flexDirection: 'column',
        
    },
    
    centered: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    BackLogButton: {
        margin: 8
    },
    tradeDrawerOpen: {
        position: 'relative',
        width: 300,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    tradeDrawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        width: 20,
        minWidth: 20
    },
    Moving: {
        
    },
    WeekdayPickerContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    StartLookaheadDialogContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    whiteSelect: {
        '&:before': {
            borderColor: '#ff',
        },
        '&:after': {
            borderColor: '#fff',
        },
        color: '#fff',
        borderColor: '#fff'
    },
    formFieldVisible: {
        opacity: .5
    },
    RowCountContainer: {
        display: 'flex',
        'align-items': 'center',
        'outline-width': '4px',
        'outline-style': 'solid'
    },
    RowCountContainerOpen: {
        justifyContent: 'flex-end',
    },
    RowCountContainerClose: {
        justifyContent: 'center',
    },
    RowCountNumberContainer: {
        height: '100%'
    },
    RowCounterTitleContainer: {
        height: "28px",
        cursor:'pointer',
        width: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        textAlign: 'center',
        zIndex: 3,
        flexDirection: 'column',
        borderLeftColor: " #fff",
        borderLeftStyle: "solid",
        borderLeftWidth: .25,
        borderRightColor: "#fff",
        borderRightStyle: "solid",
        borderRightWidth: .25,
        borderBottomColor: "#fff",
        borderBottomStyle: "solid",
        borderBottomWidth: .25,
        borderTopColor: "#fff",
        borderTopStyle: "solid",
        borderTopWidth: .50
    },
    LookaheadTitleText: {
        fontWeight: 400,
    },
    LookaheadTitleSubText: {
        fontWeight: 400,
        opacity: '60%'
    },
    TagMobileListItem: {
        width: '100%',
        marginTop: '5px',
        marginBottom: '5px',
        height: '96px',
        'border-radius': '2px',
        'border': 'solid 0.5px #dddbda',
        'background-color': '#ffffff',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    Histogram: {
        height: 50,
        width: '100%',
        paddingRight: '16px',
        paddingLeft: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },
    HistogramContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#fff'
    },
    leftOverviewHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }
});

export const tagCardStyle = (theme: Theme) => ({
    PhasePlanTagCardConstraintText:{
        '&::before': {
            shapeOutside: 'polygon\(2\% 0%\, 100\% 0%\,100\% 100%\, 2\% 100%\, 50\% 94%\, 76.6\% 82.7%\, 94\% 65.6%\, 100\% 50%\, 94\% 32.6%\, 76.6\% 17.3%\, 50\% 6\% )',
            shapeMrgin: '7%',
            content: "",
            float: 'right',
            height: '100%',
            width: '50%'
        }
    },
    PhasePlanTagCard: {
        cursor: 'pointer',
        boxShadow: '0 0.5px 1px 0 rgba(0, 0, 0, 0.5)',
        display:'flex',
        justifyContent:'center',
        alignItems: 'center',
        borderRadius: '50%',
        '& td': {
            fontFamily: 'Roboto',
            fontSize: 8,
            '-webkit-user-select': 'none',  
            '-moz-user-select': 'none',   
            '-ms-user-select': 'none',      
            'user-select': 'none'
        },
        overflowY: 'hidden',
        height: 'fit-content',
    },
    NewTagCard:{
        display:'flex',
        justifyContent:'flex-start',
        flexDirection: 'row',
        alignItems: 'flex-start',
        overflow: 'hidden',
        cursor: 'pointer',
        boxShadow: '0 0.5px 1px 0 rgba(0, 0, 0, 0.5)',
        '& td': {
            fontFamily: 'Roboto',
            fontSize: 8,
            '-webkit-user-select': 'none',  
            '-moz-user-select': 'none',   
            '-ms-user-select': 'none',      
            'user-select': 'none'
        },
        '&:before': {
            opacity: 0.5,
            content: "",
            'background-image': 'url(\'https://placekitten.com/1200/800\')',
            'background-size': 'cover',
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom:'0px',
            left: '0px',
        },
        overflowY: 'hidden',
        height: 'fit-content'
    },
    RotateTag: {
        transform: 'rotate(45deg)',
        transformOrigin: 'center'
    },
    CrossOutLineRightMilestone: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(-5px) translateX(15.5px) rotate(90deg)',
        position: 'absolute'
    }, 
    CrossOutLineLeftMilestone: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(13.5px) translateX(-4.5px) rotate(180deg)',
        position: 'absolute'
    }, 
    CrossOutLineRightMilestoneBacklog: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(-5px) translateX(27.5px) rotate(90deg)',
        position: 'absolute'
    }, 
    CrossOutLineLeftMilestoneBacklog: {
        width: '110%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(25.5px) translateX(-4.5px) rotate(180deg)',
        position: 'absolute'
    }, 
    CrossOutLineRightConstraint: {
        width: '85%',
        height: '110%',
        borderBottom: 'solid',
        transform: 'translateY(-24.5px) translateX(25px) rotate(45deg)',
        position: 'absolute'
    }, 
    CrossOutLineLeftConstraint: {
        width: '85%',
        height: '90%',
        borderBottom: 'solid',
        transform: 'translateY(19px) translateX(18px) rotate(135deg)',
        position: 'absolute'
    }, 
    CrossOutLineRightConstraintBacklog: {
        width: '90%',
        height: '110%',
        position: 'absolute',
        transform: 'translateY(-45px) translateX(43px) rotate(45deg)',
        borderBottom: 'solid',
    },
    CrossOutLineLeftConstraintBacklog: {
        width: '90%',
        height: '90%',
        position: 'absolute',
        transform: 'translateY(30px) translateX(33px) rotate(135deg)',
        borderBottom: 'solid',
    },
    TagLocationContentContainer: {
        paddingRight: '5%',
        width: '100%'
    },
    TagLocationContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        textOverflow: 'ellipse',
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: '3%',
        width: '100%',
        backgroundColor: '#4286DD',
        padding: '5%',
        color: '#fff', 
        overflow: 'auto',
        whiteSpace: 'nowrap'
    },
    TagNameContainer: {
        height: '100%',
        width: '100%',
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'flex-start'
    },
    TagCardContentBody: {
        paddingRight: '8px',
        display:'flex',
        paddingLeft: '8px',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    TagCrewContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row' 
    },
    TagCardContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '100%',
        overflow: 'auto',
        height: '100%',
        '&:before': {
            opacity: 0.5,
            content: "",
            'background-image': 'url(\'https://placekitten.com/1200/800\')',
            'background-size': 'cover',
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom:'0px',
            left: '0px',
        },

        '&::before': {
            opacity: 0.5,
            content: "",
            'background-image': 'url(\'https://placekitten.com/1200/800\')',
            'background-size': 'cover',
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom:'0px',
            left: '0px',
        }
    },
    MilestoneTitle: {
        color: '#333',
        position: 'relative',
        top: 7,
        left: -7,
        wordWrap: 'break-word',
        width: '100px',
    },
    TradeIndicator: {
        borderRadius: '4px 0px 0px 4px',
        height: '100%'
    },
    SelectedTag: {
        outlineColor: green[300]
    },
    MilestoneBackground: {
        cursor: 'pointer',
        width: 70,
        height: 70,
        backgroundColor: '#d0021b',
        overflowY: 'hidden',
        borderRadius: '10%',
        '&:hover': {
            backgroundColor: darken('#d0021b', .3)
        },
        '&:active': {
            backgroundColor: darken('#d0021b', .3)
        },
    },
    MakeOpaque: {
        opacity: '50%'
    },
    MilestoneForeground: {
        color: '#333',
        height: '50%',
        transform: 'rotate(-45deg)',
        width: '100%',
    }
})

export const columnStyle = (theme: Theme) => ({
    LookaheadTitleContainer: {
        width: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        zIndex: 3,
        flexDirection: 'column',
        borderLeftColor: " #EDEDED",
        borderLeftStyle: "solid",
        borderLeftWidth: .25,
        borderRightColor: " #EDEDED",
        borderRightStyle: "solid",
        borderRightWidth: .25,
        borderBottomColor: " #EDEDED",
        borderBottomStyle: "solid",
        borderBottomWidth: .25,
        borderTopColor: " #EDEDED",
        borderTopStyle: "solid",
        borderTopWidth: .50,
        cursor:'pointer'
    },
    LookaheadTitleContainerToday: {
        backgroundColor: '#6FCF97'
    },
    Histogram: {
        height: 50,
        width: '100%',
        paddingRight: '16px',
        paddingLeft: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },
    HistogramContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#fff'
    },
    PhasePlanLocationGridColumn: {
        height: '100vh',
        borderColor: '#EDEDED',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flex: '0 0 auto'
    },
    ColumnTitle: {
        position: 'sticky',
        top: 0,
        zIndex: 4,
        width: '100%'
    },
    PhasePlanColumn: {
        width: '100%',
        display:'flex',
        justifyContent: 'center',
        overflowY: 'visible',
        borderLeftWidth: .5,
        borderLeftStyle: 'solid',
        borderLeftColor: '#EDEDED',
        flexDirection: 'column',
        alignItems: 'center',
        'scrollbar-width': 'none',
        '-ms-overflow-style': 'none',
        '&::-webkit-scrollbar': {
          width: 0,
          background: 'transparent'
        }
    },
    OffDayBackground: {
        backgroundColor: '#d8d8d8'
    },
    LookaheadTitleText: {
        fontWeight: 400,
    },
    LookaheadTitleSubText: {
        fontWeight: 400,
        opacity: '60%'
    },
    ChartRow: {
        borderBottomStyle: "solid",
        borderBottomWidth: .25
    },
    InnerColumn: {
        height: '100%',
        width: '100%'
    },
    ForceRefreshButton: {
        '&:hover': {
            backgroundColor: 'rgba(66, 134, 221, .2)'
        }
    }
})

const drawerWidth = 240;

export const homeStyles: (theme: Theme) => StyleRules<string> = theme => createStyles({
    root: {
        display: 'flex',
        overflow: 'hidden',
        width: '100vw',
        height: '100vh',
        position: 'fixed'
    },
    LeftNavButtonRow: {
        display:'flex', 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'end'
    },
    titleWrapper: {
        display: 'flex',
        flex: 1,
        height: '45px',
        paddingLeft: '16px'
    },
    projectMenuWrapper: {
        minWidth: '0px',
        minHeight: '0px'
    },
    buttonWrapper: {
        marginLeft: '8px'
    },
    mainContent: {
        height: '100vh',
        backgroundColor: '#fafafa',
        paddingLeft: '24px',
        overflowX: 'hidden',
        width: '100%',
        
    },
    menuButton: {
        marginRight: 'auto',
        marginLeft: 'auto'
    },
    drawerPaper: {
        backgroundColor: '#4286dd',
        position: 'relative',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        paddingLeft: '16px',
        paddingRight: '16px'
    },
    drawerPaperClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        width: theme.spacing.unit * 7,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 9
        }
    },
    appBar: {
        height: '45px',
        backgroundColor: 'white',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${theme.spacing.unit * 9}px)`
        }
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    homeListDivider: {
        backgroundColor: '#4286dd'
    },
    navTitle: {
        paddingRight: '1em'
    },
    navTitleText: {
        textAlign: 'center',
        marginBottom: '1em',
        opacity: '0.7'
    },
    navTitleIcon: {
        marginRight: '0.75em',
        width: '18.8px',
        height: '40.8px'
    },
    navTextHeaders: {
        color: '#ffffff',
        opacity: '0.7'
    },
    navListItems: {
        height: '3em',
        borderRadius: '0.25em',
        marginBottom: '0.15em',
        paddingLeft: '16px',
        paddingRight: '16px'
    },
    navText: {
        color: '#ffffff',
        opacity: '0.7',
        marginTop: '1.4em',
        position: 'relative',
        right: '1em',
        fontSize: '14px'
    },
    navTextIcons: {
        color: '#ffffff',
        opacity: '0.7'
    },
    projectSearch: {
        backgroundColor: '#ffffff',
        height: '2em',
        marginBottom: '1em',
        borderRadius: '0.15em',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    projectSearchDetail: {
        fontSize: '1em',
        color: 'rgba(8, 24, 40, 0.56)',
        padding: '0.25em 0 0 0.5em'
    },
    projectSearchButton: {
        color: 'rgba(0, 0, 0, 0.32)',
        float: 'right'
    },
    helpCenterContainer: {
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: '16px',
        flexDirection: 'column'
    },
    helpCenterButton: {
        marginTop: '4px'
    },
    liveChatButton: {
        color: '#fff'
    },
    requestFeatureButton: {
        color: '#ffffff'
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    wifiDisconnected: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '-1rem',
        padding: '0.1rem',
        backgroundColor: red[600],
        fontSize: '12px',
        color: '#ffffff'
    },
    wifiOffIcon: {
        fontSize: 'inherit',
        marginRight: '12px',
    },
    fullCenter: {
        display: 'flex',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    }
});

export const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
      }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
      },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.text.secondary
    },
    title: {
        flex: '0 0 auto'
    },

})

export const dockPadTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#4286dd'
        }
    }
})

export const WhiteTextTypography = withStyles({
    root: {
        color: '#ffffff'
    }
})(Typography)

export const WhiteButton = withStyles({
    root: {
        color: '#ffffff',
        backgroundColor: 'transparent',
        borderColor: '#fff',
        opacity: '1',
        '&:hover': {
            opacity: '.2'
        }
    }
})(Button)

export const WhiteTextField = withStyles({
    root: {
        color: '#ffffff',
        backgroundColor: 'transparent',
        borderColor: '#fff',
        opacity: '1',
        '&:hover': {
            opacity: '.2'
        },
        background: "white",
        "& label.Mui-focused": {
            color: "white"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "white"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "white"
            },
            "&:hover fieldset": {
                borderColor: "white"
            },
            "&.Mui-focused fieldset": {
                borderColor: "white"
            }
        }
    },
    overrides: {
        MuiInputBase: {
            input: {
                background: "#fff",
            },
        },
    }
})(TextField)

export const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        color: 'white',
      },
      '& .MuiInputBase-root': {
        color: 'white',
      },
      '& .MuiInput-underline': {
        color: 'white'

      },
      '& .MuiInput-underline:after': {
        color: 'white',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
            color: 'white',
        },
        '&:hover fieldset': {
            color: 'white',
        },
        '&.Mui-focused fieldset': {
            color: 'white',
        },
      },
    },
  })(TextField)




// WEBPACK FOOTER //
// ./src/containers/dockPadStyle.tsx